var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_c('button',{staticClass:"btn button-back-to-shop",attrs:{"type":"button","title":_vm.$t('error.linkBackUrlSet')},on:{"click":_vm.goBackToShop}},[(_vm.isBackUrlSet)?_c('span',[_vm._v(_vm._s(_vm.$t('error.linkBackUrlSet')))]):_vm._e(),(!_vm.isBackUrlSet)?_c('span',[_vm._v(_vm._s(_vm.$t('error.linkBackUrlNotSet')))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }